import { render, staticRenderFns } from "./header-task-filters.vue?vue&type=template&id=6130b694&"
import script from "./header-task-filters.vue?vue&type=script&lang=js&"
export * from "./header-task-filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports